module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "campus-life-right.4ada6828.webp" + "?" + Date.now();